import { RowCard } from '../../catalogProductsListV2.types';
import { getCatalogSelectionSectionProductId } from '../../components/catalogProductRowV2.utils';
import { CatalogMassActionsContextValue } from '../../contexts/CatalogMassActions.context';

interface BuildCatalogListRowSelectionParams {
  massActions: CatalogMassActionsContextValue;
  card: Extract<RowCard, { kind: 'item' }>;
  productName: string;
}

export const buildCatalogListRowSelection = ({
  massActions,
  card,
  productName,
}: BuildCatalogListRowSelectionParams) => {
  if (massActions.readMode) {
    return undefined;
  }

  return {
    isSelected: massActions.isSelected(card.esProduct.id),
    isLocked: massActions.isSelectionLocked,
    productName,
    onToggle: () =>
      massActions.toggle({
        productId: card.esProduct.id,
        sectionProductId: getCatalogSelectionSectionProductId(card.esProduct),
      }),
  };
};
